export const engagementAppGroupIdFeatureLimitations = "/engagement/:app_group_id/feature_limitations" as const;
